<template>
  <div class="mx-auto flex max-w-8xl rounded-md bg-white py-6 shadow-md mt-4">
    <div class="hidden max-w-sm flex-shrink-0 lg:block">
      <img src="img/home.jpg" class="rounded-r-2xl" alt="" />
    </div>

    <div class="flex w-full flex-col px-10 pt-6 ">
      <HomeInfo />
      <div class="flex flex-1 justify-center py-10">
        <div class="flex h-full w-full flex-col justify-center gap-6 md:flex-row">
          <RouterLink v-for="(route, index) in routes" :key="index"
            class="flex flex-1 flex-col items-center justify-center space-y-4 rounded-lg bg-white p-6 shadow-md ring-1 ring-gray-200 transition duration-200 ease-in-out hover:ring-gray-400/50 focus:outline-none focus:ring-colescba-blue-700"
            tag="button" type="button" :to="route">
            <Component :is="route.meta.icon.svg" class="h-16 w-16 text-colescba-blue-700"
              :class="route.meta.icon.svg" />
            <span class="font-medium text-gray-600" :class="route.meta.title.classes">
              {{ route.meta.title.text }}
            </span>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HomeInfo } from '@/components/home'
import { useAccessControl } from '@/mixins/accessControl'
import { useAcreditacionServicio, useSession } from '@colescba/ui'

import { routes } from '@/config'

export default {
  components: {
    HomeInfo,
  },
  mixins: [useSession(), useAcreditacionServicio(), useAccessControl()],

  data() {
    return {
      routes: [],
    }
  },

  mounted() {
    this.routes = routes
      .filter(route => route.name != 'Home' && route.meta.isNavigationLink)
      .filter(route => {
        if (route.meta?.accionCodigo) {
          return this.acreditaRuta(route)
        }

        return true
      })
  },
}
</script>
